import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import SEO from '../SEO'; // Import the SEO component
import cinnamonImage from '../assets/cinnamon/Untitled design.png';
import ceylonCinnamon from '../assets/cinnamon/71Xcgm80gxL.jpg';
import cassiaCinnamon from '../assets/cinnamon/bark-Cinnamomum-cassia-plant-spice.webp';
import saigonCinnamon from '../assets/cinnamon/Saigoncinnamon.jpg';
import korintjeCinnamon from '../assets/cinnamon/4f35fbde-ab58-4262-8dbc-381f6a98b884.__CR0,0,300,300_PT0_SX300_V1___.jpg';
import alba from '../assets/cinnamon/ALBA-ceylon-cinnamon-sticks.006424f3c5eea992585f.jpg';
import c5 from '../assets/cinnamon/download (1).jpeg';
import c4 from '../assets/cinnamon/C4-Cinnamon-sticks-Side-view.51bf9463f91eef5e977c.webp';
import m5 from '../assets/cinnamon/cinnamon-m5.jpg';
import m4 from '../assets/cinnamon/images-26-1-500x500.webp';
import h1 from '../assets/cinnamon/h1-cinnamon.jpg';
import h2 from '../assets/cinnamon/H2-Cinnamon-Sticks-Side-View.webp';
import cinnamonPowder from '../assets/cinnamon/Ceyndulgent-Cinnamon-Powder-r2.jpg';
import cinnamonOil from '../assets/cinnamon/cinnamon-bark-essential-oil-on-600nw-1682221552.webp';

const HistoryOfCinnamon = () => {
    const cinnamonGrades = [
        { id: 1, name: 'Alba', image: alba, alt: 'Alba Ceylon Cinnamon Sticks' },
        { id: 2, name: 'C5', image: c5, alt: 'C5 Ceylon Cinnamon Sticks' },
        { id: 3, name: 'C4', image: c4, alt: 'C4 Ceylon Cinnamon Sticks' },
        { id: 4, name: 'M5', image: m5, alt: 'M5 Ceylon Cinnamon Sticks' },
        { id: 5, name: 'M4', image: m4, alt: 'M4 Ceylon Cinnamon Sticks' },
        { id: 6, name: 'H1', image: h1, alt: 'H1 Ceylon Cinnamon Sticks' },
        { id: 7, name: 'H2', image: h2, alt: 'H2 Ceylon Cinnamon Sticks' },
        { id: 8, name: 'Cinnamon Powder', image: cinnamonPowder, alt: 'Ceylon Cinnamon Powder' },
        { id: 9, name: 'Cinnamon Oil', image: cinnamonOil, alt: 'Ceylon Cinnamon Essential Oil' }
    ];

    const [currentIndex, setCurrentIndex] = React.useState(0);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex + 3 >= cinnamonGrades.length ? 0 : prevIndex + 3
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex - 3 < 0 ? Math.max(0, cinnamonGrades.length - 3) : prevIndex - 3
        );
    };

    const visibleGrades = cinnamonGrades.slice(currentIndex, currentIndex + 3);

    const cinnamonBenefits = [
        "Rich in antioxidants",
        "Has anti-inflammatory properties",
        "Supports heart health",
        "Helps regulate blood sugar",
        "May protect brain function",
        "Has antibacterial and antifungal effects",
        "Boosts immune system",
        "Freshens breath and improves oral health",
        "Aids digestion"
    ];

    // SEO Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "History of Cinnamon - Galle Ceylon Spices International",
        "description": "Explore the rich history of Ceylon cinnamon, its types, grades, and health benefits. Learn about Sri Lanka’s ancient spice trade and the unique qualities of true cinnamon.",
        "url": "https://www.galleceylonspices.com/history-of-cinnamon",
        "publisher": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo.png"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "448/2, Nawadagala",
                "addressLocality": "Elpitiya",
                "postalCode": "80000",
                "addressCountry": "Sri Lanka"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+94-77-929-1829",
                "contactType": "Customer Service",
                "areaServed": "Worldwide",
                "availableLanguage": "English"
            }
        },
        "mainEntity": {
            "@type": "Article",
            "headline": "History and Benefits of Ceylon Cinnamon",
            "description": "Discover the 2,000-year history of Ceylon cinnamon, its cultivation in Sri Lanka, types like Cassia and Saigon, premium grades, and health benefits including antioxidant and anti-inflammatory properties.",
            "image": cinnamonImage,
            "author": {
                "@type": "Organization",
                "name": "Galle Ceylon Spices International (Pvt) Ltd"
            },
            "datePublished": "2025-05-25",
            "dateModified": "2025-05-25"
        }
    };

    return (
        <div className="container my-4 py-4">
            <SEO
                title="History of Cinnamon - Galle Ceylon Spices International"
                description="Explore the rich history of Ceylon cinnamon, its types, grades, and health benefits. Learn about Sri Lanka’s ancient spice trade and the unique qualities of true cinnamon."
                keywords="Ceylon cinnamon, cinnamon history, Sri Lankan spices, cinnamon types, cinnamon grades, cinnamon health benefits, Galle Ceylon Spices, true cinnamon"
                canonicalUrl="https://www.galleceylonspices.com/history-of-cinnamon"
                ogImage="%PUBLIC_URL%/logo.png"
                structuredData={structuredData}
            />
            {/* History Section */}
            <div className="animate__animated animate__fadeIn" style={{ animationDuration: '1s' }}>
                <h1
                    className="text-center mb-2 position-relative"
                    style={{
                        fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
                        color: '#355E3B',
                        fontFamily: 'Georgia',
                        lineHeight: '1.2',
                    }}
                >
                    History of Cinnamon
                    <span
                        style={{
                            position: 'absolute',
                            bottom: '-8px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '80px',
                            height: '2px',
                            backgroundColor: '#C19A6B',
                            borderRadius: '2px',
                        }}
                    />
                </h1>
                <h5
                    className="text-center mb-4"
                    style={{
                        color: '#666',
                        fontFamily: 'Georgia',
                        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                    }}
                >
                    Ceylon's Ancient Spice Story
                </h5>

                <div className="row mt-4">
                    <div className="col-12 col-md-6 mb-3" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                        <p style={{ fontFamily: 'Georgia', color: '#355E3B', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.6' }}>
                            Cinnamon has been an integral part of Sri Lanka's history for over 2,000 years. Native to the island, Ceylon cinnamon (Cinnamomum verum) was highly valued in ancient times for its flavor, aroma, and medicinal properties. It was widely used in local traditions and soon became a sought-after commodity by foreign traders. Arab merchants once controlled the trade and kept the true source of cinnamon a secret, allowing them to sell it at high prices in Europe and the Middle East.
                        </p>
                        <p style={{ fontFamily: 'Georgia', color: '#355E3B', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.6' }}>
                            The arrival of the Portuguese in 1505 marked the beginning of colonial control over cinnamon in Sri Lanka. They established a monopoly and exploited local communities for its production. This was later taken over by the Dutch in 1658, who expanded cinnamon plantations and improved harvesting methods, making Sri Lanka the world's leading cinnamon exporter. The British continued the trade after 1796, though they gradually shifted focus to other crops like tea and rubber.
                        </p>
                        <p style={{ fontFamily: 'Georgia', color: '#355E3B', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.6' }}>
                            Today, Sri Lanka remains the world's largest producer of Ceylon cinnamon, renowned for its superior quality and low coumarin content compared to other types like Cassia. The southern coastal regions, especially around Galle and Matara, continue traditional methods of cultivation. Cinnamon remains a vital part of Sri Lanka's cultural identity and economy, celebrated for its unique heritage and global appeal.
                        </p>
                        <p style={{ fontFamily: 'Georgia', color: '#355E3B', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.6' }}>
                            Cinnamon's trade routes stretched across the ancient world, notably along the Silk Road, where it was exchanged alongside silk and spices. Venetian and Genoese merchants dominated its distribution in Europe by the Middle Ages, driving its value to rival gold in some markets.
                        </p>
                        <p style={{ fontFamily: 'Georgia', color: '#355E3B', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.6' }}>
                            In ancient medicine, cinnamon was a cornerstone of Ayurvedic practices in India and traditional Chinese medicine, used to treat colds, digestive issues, and even as an aphrodisiac. Its antibacterial properties were recognized early, making it a preservative in food and a remedy for infections.
                        </p>
                        <p style={{ fontFamily: 'Georgia', color: '#355E3B', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.6' }}>
                            Economically, cinnamon supports thousands of livelihoods in Sri Lanka, with exports reaching over 80 countries. Sustainable farming practices are now prioritized to preserve its quality and meet growing global demand for organic spices.
                        </p>
                        <style>
                            {`
        @media (max-width: 576px) {
            p {
                text-align: center;
            }
        }
    `}
                        </style>
                    </div>
                    <div className="col-12 col-md-6 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.6s', animationDuration: '0.8s' }}>
                        <img
                            src={cinnamonImage}
                            alt="Ceylon Cinnamon Historical Trade"
                            className="img-fluid rounded shadow-sm"
                            loading="lazy"
                            style={{ width: '100%', height: 'clamp(500px, 65vw, 1000px)' }}
                            onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/600x400?text=Cinnamon+History';
                                console.error('Failed to load cinnamonImage');
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Section: Types of Cinnamon */}
            <div className="mt-4">
                <h2
                    className="text-center mb-4 position-relative"
                    style={{
                        fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                        color: '#355E3B',
                        fontFamily: 'Georgia',
                        fontWeight: 'bold',
                    }}
                >
                    Types of Cinnamon
                    <span
                        style={{
                            position: 'absolute',
                            bottom: '-8px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '80px',
                            height: '2px',
                            backgroundColor: '#C19A6B',
                            borderRadius: '2px',
                        }}
                    />
                </h2>
                <div className="row">
                    {[
                        {
                            title: 'Ceylon Cinnamon (True Cinnamon)',
                            image: ceylonCinnamon,
                            alt: 'Ceylon True Cinnamon Sticks',
                            details: [
                                { label: 'Botanical name', value: 'Cinnamomum verum or Cinnamomum zeylanicum' },
                                { label: 'Origin', value: 'Native to Sri Lanka' },
                                { label: 'Flavor', value: 'Mild, sweet, and delicate' },
                                { label: 'Color & Texture', value: 'Light brown with thin, soft, multiple layers' },
                                { label: 'Coumarin Content', value: 'Very low (safer for regular use)' },
                                { label: 'Uses', value: 'Desserts, teas, fine cooking' },
                                { label: 'Price', value: 'More expensive, high quality' },
                            ],
                        },
                        {
                            title: 'Cassia Cinnamon (Common Cinnamon)',
                            image: cassiaCinnamon,
                            alt: 'Cassia Cinnamon Bark',
                            details: [
                                { label: 'Botanical name', value: 'Cinnamomum cassia or Cinnamomum aromaticum' },
                                { label: 'Origin', value: 'Primarily China' },
                                { label: 'Flavor', value: 'Stronger, spicier, pungent' },
                                { label: 'Color & Texture', value: 'Dark reddish-brown, thick bark' },
                                { label: 'Coumarin Content', value: 'High (harmful in large quantities)' },
                                { label: 'Uses', value: 'Processed foods, baking' },
                                { label: 'Price', value: 'Cheaper, widely available' },
                            ],
                        },
                        {
                            title: 'Saigon Cinnamon (Vietnamese Cassia)',
                            image: saigonCinnamon,
                            alt: 'Saigon Cinnamon Bark',
                            details: [
                                { label: 'Botanical name', value: 'Cinnamomum loureiroi' },
                                { label: 'Origin', value: 'Vietnam' },
                                { label: 'Flavor', value: 'Strong, sweet, spicy; high oil' },
                                { label: 'Color & Texture', value: 'Dark, thick bark' },
                                { label: 'Coumarin Content', value: 'High' },
                                { label: 'Uses', value: 'Strong dishes, spicy sweets' },
                            ],
                        },
                        {
                            title: 'Indonesian Cinnamon (Korintje)',
                            image: korintjeCinnamon,
                            alt: 'Korintje Indonesian Cinnamon',
                            details: [
                                { label: 'Botanical name', value: 'Cinnamomum burmannii' },
                                { label: 'Origin', value: 'Indonesia' },
                                { label: 'Flavor', value: 'Milder than Saigon, stronger than Ceylon' },
                                { label: 'Coumarin Content', value: 'Moderate to high' },
                                { label: 'Uses', value: 'Commercial baking, cinnamon rolls' },
                            ],
                        },
                    ].map((type, index) => (
                        <div
                            key={type.title}
                            className="col-12 col-sm-6 col-md-3 mb-3 animate__animated animate__fadeInUp"
                            style={{ animationDelay: `${0.2 * (index + 1)}s`, animationDuration: '0.8s' }}
                        >
                            <div
                                className="card h-100 shadow-sm"
                                style={{
                                    border: '1px solid rgba(193, 154, 107, 0.3)',
                                    borderRadius: '8px',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 6px 15px rgba(193, 154, 107, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                                }}
                            >
                                <img
                                    src={type.image}
                                    className="card-img-top img-fluid"
                                    alt={type.alt}
                                    loading="lazy"
                                    style={{ height: 'clamp(250px, 30vw, 250px)', objectFit: 'cover' }}
                                    onError={(e) => (e.target.src = `https://via.placeholder.com/300x250?text=${type.title}`)}
                                />
                                <div className="card-body text-center p-3" style={{ backgroundColor: '#fff' }}>
                                    <h5
                                        className="card-title"
                                        style={{
                                            color: '#355E3B',
                                            fontFamily: 'Georgia',
                                            fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                            fontWeight: 'bold',
                                            marginBottom: '8px',
                                        }}
                                    >
                                        {type.title}
                                    </h5>
                                    <ul className="list-unstyled" style={{ fontFamily: 'Georgia', fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)', color: '#666' }}>
                                        {type.details.map((detail, idx) => (
                                            <li key={idx}>
                                                <strong>{detail.label}:</strong> {detail.value}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Section: Grades of Cinnamon */}
            <div className="mt-4">
                <h2
                    className="text-center mb-4 position-relative"
                    style={{
                        fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                        color: '#355E3B',
                        fontFamily: 'Georgia',
                        fontWeight: 'bold',
                    }}
                >
                    Grades of Cinnamon
                    <span
                        style={{
                            position: 'absolute',
                            bottom: '-8px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '80px',
                            height: '2px',
                            backgroundColor: '#C19A6B',
                            borderRadius: '2px',
                        }}
                    />
                </h2>

                <div className="d-flex align-items-center justify-content-center position-relative animate__animated animate__fadeIn" style={{ animationDuration: '1s' }}>
                    <button
                        onClick={prevSlide}
                        className="btn rounded-circle p-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: '#C19A6B',
                            border: 'none',
                            color: '#FFFFFF',
                            width: 'clamp(35px, 5vw, 50px)',
                            height: 'clamp(35px, 5vw, 50px)',
                            transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#A67B4D';
                            e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#C19A6B';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <FaChevronLeft style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)' }} />
                    </button>

                    <div className="d-flex justify-content-center" style={{ width: '100%', minHeight: 'clamp(200px, 40vw, 300px)' }}>
                        <div className="row" style={{ width: '100%' }}>
                            {visibleGrades.map((grade) => (
                                <div
                                    key={grade.id}
                                    className="col-12 col-sm-4 mb-3"
                                >
                                    <div
                                        className="card h-100 shadow-lg"
                                        style={{
                                            border: '1px solid rgba(193, 154, 107, 0.3)',
                                            borderRadius: '8px',
                                            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
                                        }}
                                    >
                                        <img
                                            src={grade.image}
                                            className="card-img-top img-fluid"
                                            alt={grade.alt}
                                            loading="lazy"
                                            style={{ height: 'clamp(250px, 30vw, 350px)', objectFit: 'cover', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                                            onError={(e) => (e.target.src = 'https://via.placeholder.com/300x200?text=Cinnamon+Grade')}
                                        />
                                        <div className="card-body text-center p-2">
                                            <h5
                                                className="card-title"
                                                style={{
                                                    color: '#355E3B',
                                                    fontFamily: 'Georgia',
                                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {grade.name}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <button
                        onClick={nextSlide}
                        className="btn rounded-circle p-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: '#C19A6B',
                            border: 'none',
                            color: '#FFFFFF',
                            width: 'clamp(35px, 5vw, 50px)',
                            height: 'clamp(35px, 5vw, 50px)',
                            transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#A67B4D';
                            e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#C19A6B';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <FaChevronRight style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)' }} />
                    </button>
                </div>

                <div className="text-center mt-2">
                    {Array.from({ length: Math.ceil(cinnamonGrades.length / 3) }).map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentIndex(index * 3)}
                            className={`btn btn-sm mx-1 rounded-circle ${currentIndex === index * 3 ? 'active' : ''}`}
                            style={{
                                backgroundColor: currentIndex === index * 3 ? '#C19A6B' : '#FFFFFF',
                                color: currentIndex === index * 3 ? '#FFFFFF' : '#C19A6B',
                                border: '1px solid #C19A6B',
                                width: 'clamp(25px, 4vw, 35px)',
                                height: 'clamp(25px, 4vw, 35px)',
                                transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
                            }}
                            onMouseEnter={(e) => {
                                if (currentIndex !== index * 3) {
                                    e.currentTarget.style.backgroundColor = '#A67B4D';
                                    e.currentTarget.style.color = '#FFFFFF';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (currentIndex !== index * 3) {
                                    e.currentTarget.style.backgroundColor = '#FFFFFF';
                                    e.currentTarget.style.color = '#C19A6B';
                                }
                            }}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            </div>

            {/* Section: Benefits of Cinnamon */}
            <div className="row mt-4 mb-4" style={{ paddingTop: '20px' }}>
                <div className="col-12 col-md-6 mb-3 animate__animated animate__fadeInUp d-flex justify-content-center align-items-center" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                    <div
                        className="card shadow-lg"
                        style={{
                            border: '1px solid rgba(193, 154, 107, 0.3)',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            width: '100%',
                        }}
                    >
                        <iframe
                            width="100%"
                            height="auto"
                            src="https://www.youtube.com/embed/rGtciv3kNXY"
                            title="12 Benefits of Cinnamon You Should Know! | Cinnamon Health Benefits"
                            frameBorder="0"
                            allow="accelerometer; autoplay  clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            style={{ width: '100%', height: 'clamp(200px, 40vw, 600px)', border: 'none', aspectRatio: '16/9' }}
                        />
                    </div>
                </div>
                <div className="col-12 col-md-6 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s', animationDuration: '0.8s' }}>
                    <h2
                        className="mb-3 position-relative"
                        style={{
                            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                            color: '#355E3B',
                            fontFamily: 'Georgia',
                            fontWeight: 'bold',
                        }}
                    >
                        Health Benefits of Cinnamon
                        <span
                            className="underline-span"
                            style={{
                                position: 'absolute',
                                bottom: '-8px',
                                left: '0',
                                width: '80px',
                                height: '2px',
                                backgroundColor: '#C19A6B',
                                borderRadius: '2px',
                            }}
                        />
                        <style>
                            {`
            @media (max-width: 576px) {
                .mb-3.position-relative {
                    text-align: center;
                }
                .underline-span {
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                }
            }
        `}
                        </style>
                    </h2>
                    <ul className="list-group" style={{ borderRadius: '8px' }}>
                        {cinnamonBenefits.map((benefit, index) => (
                            <li
                                key={index}
                                className="list-group-item d-flex align-items-center"
                                style={{
                                    borderLeft: '4px solid #C19A6B',
                                    marginBottom: '6px',
                                    backgroundColor: '#FFFFFF',
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                    color: '#355E3B',
                                    padding: 'clamp(6px, 1.5vw, 10px) clamp(10px, 2vw, 15px)',
                                    transition: 'background-color 0.3s ease-in-out',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#FFFFFF')}
                            >
                                <span className="me-2" style={{ color: '#C19A6B' }}>•</span>
                                {benefit}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default HistoryOfCinnamon;